// extracted by mini-css-extract-plugin
export default {"swiperDis":"Featured_swiperDis__eb5ul","features":"Featured_features__AF47U"};